import { Avatar, Badge, Card, Col, List, Row, Modal, message, Breadcrumb, Tabs } from "antd";
import { useEffect, useState } from "react";
import { MceEditor } from "shared/components/tinymce/mce-editor";
import { DefaultErrorMessage, UpdateDataSuccessfully } from "shared/constants/define-localization";
import { ReferenceAndCommentModel } from "shared/models/reference-comment-model";
import { CoreResource, t } from "shared/plugins/localization";
import { redirectFileLocalUrl } from "shared/plugins/string-helper";
import { addComment, getReferenceHasNewComment, searchCommentList } from "states/comment/comment.api";
import { CommentModel, CreatedCommentModel, SearchCommentRequestModel } from "states/comment/comment.models";
import { PagedResult } from "states/paged-result-model";
import { CommentItem } from "./comment-item";

export interface ICommentTabProps {
  commentType: string;
  title: string;
  selectedReference?: number;
  onChangeSelectReference: (id: number) => void;
}

export function CommentTab(props: ICommentTabProps) {
  const { commentType, title, selectedReference, onChangeSelectReference } = props;
  const [referenceCommentCounts, setReferenceCommentCounts] = useState({
    currentPage: 1,
    pageSize: 50,
    results: [] as ReferenceAndCommentModel[],
  } as PagedResult<ReferenceAndCommentModel>);
  const [replyCommentModel, setReplyCommentModel] = useState<{
    commentModel: CreatedCommentModel,
    isSubmitted: boolean
  }>({
    commentModel: {} as CreatedCommentModel,
    isSubmitted: false
  });
  const [replyModal, setReplyModal] = useState<boolean>();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingComments, setIsLoadingComments] = useState(false);
  const [comments, setComments] = useState<CommentModel[]>(
    []
  );
  const onSubmit = async () => {
    setReplyCommentModel({ ...replyCommentModel, isSubmitted: true });

    try {
      await addComment({ ...replyCommentModel.commentModel });
      setReplyCommentModel({
        commentModel: {} as CommentModel,
        isSubmitted: false
      });
      setReplyModal(false);
      await handleGetComment();
      message.success("Cập nhật thành công");
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
        "Lỗi hệ thống"
      );
    }
    setReplyCommentModel({ ...replyCommentModel, isSubmitted: false });
  };
  const gotoPage = async (page: number) => {
    setIsLoading(true);
    const res = await getReferenceHasNewComment(commentType, page);
    setReferenceCommentCounts(res.data);
    setIsLoading(false);
  };

  const handleGetComment = async () => {
    if (selectedReference) {
      setIsLoadingComments(true);
      const res = await searchCommentList({
        referenceId: selectedReference,
        commentType: commentType,
      } as SearchCommentRequestModel);
      setComments(res.data);
      setIsLoadingComments(false);
    } else {
      setComments([]);
    }
  };

  const onUpdatedCommentItem = () => {
    handleGetComment();
  };

  useEffect(() => {
    gotoPage(1);
  }, []);

  useEffect(() => {
    handleGetComment();
  }, [selectedReference]);
  return (
    <div className="comment-tab">
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Card title={`Danh sách ${title}`}>
            <List
              loading={isLoading}
              size="small"
              dataSource={referenceCommentCounts.results}
              pagination={{
                total: referenceCommentCounts.totalItemCount,
                pageSize: referenceCommentCounts.pageSize,
                current: referenceCommentCounts.currentPage,
                onChange: gotoPage,
              }}
              renderItem={(reference) => (
                <List.Item
                  key={reference.id}
                  style={{
                    cursor: "pointer",
                    background:
                      reference.id === selectedReference ? "#d9d9d9" : "#fff",
                  }}
                  onClick={() => {
                    onChangeSelectReference(reference.id);
                  }}
                >
                  <List.Item.Meta
                    avatar={
                      <Badge count={reference.numberOfNewComments}>
                        <Avatar
                          className="bg-primary"
                          src={
                            reference.images.length > 0
                              ? redirectFileLocalUrl(reference.images[0])
                              : null
                          }
                        >
                          {reference.websiteName && reference.websiteName[0]}
                        </Avatar>
                      </Badge>
                    }
                    title={reference.websiteName}
                  ></List.Item.Meta>
                </List.Item>
              )}
            ></List>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Danh sách bình luận / đánh giá">
            <List
              loading={isLoadingComments}
              size="small"
              dataSource={comments}
              header={`${comments.length} bình luận`}
              renderItem={(comment) => (
                <li>
                  <CommentItem
                    model={comment}
                    onReplyBtnClicked={(commentId: number) => {
                      setReplyCommentModel({
                        ...replyCommentModel, commentModel: {
                          referenceId: selectedReference,
                          commentType: commentType,
                          message: "",
                          parentId: commentId,
                        } as CreatedCommentModel
                      });
                      setReplyModal(true);
                    }}
                    onUpdated={onUpdatedCommentItem}
                  ></CommentItem>
                </li>
              )}
            ></List>
          </Card>
        </Col>
      </Row>
      <Modal
        width="800px"
        visible={replyModal}
        title="Trả lời bình luận"
        onOk={onSubmit}
        onCancel={() => {
          setReplyModal(false);
        }}
        okText="Lưu"
        cancelText="Hủy bỏ"
        confirmLoading={replyCommentModel?.isSubmitted}
      >
        <MceEditor
          pageContent={replyCommentModel?.commentModel?.message}
          onChange={(value) => {
            setReplyCommentModel({ ...replyCommentModel, commentModel: { ...replyCommentModel.commentModel, message: value } });
          }}
        ></MceEditor>
      </Modal>
    </div>
  );
}
